import { SOCIAL_BULK_FIELDS } from '@utils/socialLinkUtils';

const SOCIAL_LINK_OPTIONS = SOCIAL_BULK_FIELDS.map(({ key, label, fieldValue }) => ({
    value: fieldValue,
    label: 'BulkEditLocations.socialLinkPlatform',
    labelParams: { platform: label },
    component: 'SocialLink',
    platform: key,
}));

export const EDITABLE_FIELDS = [
    {
        value: 'locationName',
        label: 'SettingsCompanies.locationName',
        component: 'Input',
    },
    {
        value: 'status',
        label: 'common.status',
        component: 'Select',
    },
    {
        value: 'phoneNumber',
        label: 'SettingsCompanies.primaryPhone',
        component: 'PhoneInput',
    },
    {
        value: 'email',
        label: 'common.email',
        component: 'Input',
        inputType: 'email',
    },
    {
        value: 'website',
        label: 'SettingsCompanies.website',
        component: 'Input',
        inputType: 'url',
    },
    {
        value: 'workingHours',
        label: 'SettingsCompanies.businessHours',
        component: 'BusinessHoursSelection',
    },
    {
        value: 'specialHours',
        label: 'SettingsCompanies.specialHours',
        component: 'SpecialHoursSelection',
    },
    {
        value: 'shortDescription',
        label: 'SettingsCompanies.descriptionShort',
        component: 'Input',
        multiline: true,
        maxLength: 75,
    },
    {
        value: 'mediumDescription',
        label: 'SettingsCompanies.descriptionMedium',
        component: 'Input',
        multiline: true,
        maxLength: 500,
    },
    {
        value: 'longDescription',
        label: 'SettingsCompanies.descriptionLong',
        component: 'Input',
        multiline: true,
        maxLength: 750,
    },
    {
        value: 'openingDate',
        label: 'Listings.openingDate',
        component: 'TimeframePicker',
    },
    {
        value: 'services',
        label: 'BulkEditLocations.services',
        component: 'ServicesArray',
    },
    {
        value: 'paymentMethods',
        label: 'common.paymentMethods',
        component: 'CheckboxGroup',
    },
    ...SOCIAL_LINK_OPTIONS,
    {
        value: 'logoUrl',
        label: 'common.logo',
        component: 'ImageUploaderSingle',
        imageType: 'logo',
    },
    {
        value: 'coverUrl',
        label: 'SettingsCompanies.coverPhoto',
        component: 'ImageUploaderSingle',
        imageType: 'cover',
    },
];
